import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { publishReplay, refCount } from 'rxjs/operators';
import 'rxjs/Rx';
import { Language } from '../../models/language.model';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class LanguageService {

  languageEditing: Language;
  private cachedFields: Observable<any>;

  constructor (
    private h: HttpClientService,
    private srvNotify: MessageService
  ) { }

  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<any> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.h.getPaged('/koncentro-common/language/languages' +
      (params.toString() ? '?' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : '' ));
  }

  getAll() {
    return this.h.get('/koncentro-common/language/languages')
      .map(res => {
        return res;
      });
  }

  delete(record) {
    return this.h.delete('/koncentro-common/language/languages/' + record.id)
      .map(res => {
        this.srvNotify.add({severity: 'info', summary: 'Confirmed', detail: 'Language deleted'});
      });
  }

  recover(record) {
    return this.h.put('/koncentro-common/language/languages/recover/' + record.id, null)
      .map(res => {
        this.srvNotify.add({severity: 'info', summary: 'Confirmed', detail: 'Language recovered'});
      });
  }

  post(newData) {
    return this.h.post('/koncentro-common/language/languages/', newData)
      .map(res => {
        newData.id = res.id;
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });

  }

  put(newData) {
    return this.h.put('/koncentro-common/language/languages/', newData)
      .map(res => {
        Object.assign(this.languageEditing, newData);
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get('/koncentro-common/schema/LanguageDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/language/language.service.ts